<template>
    <BasicDropdown
        :options="langs"
        v-model="selectedLang"
        class="language-selector"
        :alignement="alignement"
        :neededPlaceholder="false"
        name="language-selector"
        @update:modelValue="updateLanguage"
    >
        <template #selected>
            <img :src="selectedLang.img" alt="" class="flag-wrapper" />
            {{ selectedLang.name }}
        </template>
        <template #options="{ name, img }">
            <img :src="img" alt="" class="flag-wrapper" />
            {{ name }}
        </template>
    </BasicDropdown>
</template>

<script>
import BasicDropdown from "@/components/basic/BasicDropdown.vue"

export default {
    name: "LanguageSelector",
    components: {
        BasicDropdown,
    },
    props: {
        alignement: {
            type: String,
            default: "auto",
        },
    },
    data() {
        return {
            langs: [
                {
                    name: "France",
                    value: "fr",
                    img: require("@/assets/images/flags/fr.png"),
                },
                {
                    name: "United Kingdom",
                    value: "en",
                    img: require("@/assets/images/flags/gb.png"),
                },
                {
                    name: "Suisse (Français)",
                    value: "ch-fr",
                    img: require("@/assets/images/flags/ch.png"),
                },
                {
                    name: "Schweiz (Deutsch)",
                    value: "ch-de",
                    img: require("@/assets/images/flags/ch.png"),
                },
                {
                    name: "Danmark",
                    value: "dk",
                    img: require("@/assets/images/flags/dk.png"),
                },
                {
                    name: "Suomi",
                    value: "fi",
                    img: require("@/assets/images/flags/fi.png"),
                },
                {
                    name: "Deutschland",
                    value: "de",
                    img: require("@/assets/images/flags/de.png"),
                },
                {
                    name: "Belgique (Français)",
                    value: "be-fr",
                    img: require("@/assets/images/flags/be.png"),
                },
                {
                    name: "België (Vlaams)",
                    value: "be-fl",
                    img: require("@/assets/images/flags/be.png"),
                },
                {
                    name: "Luxembourg (Français)",
                    value: "lu-fr",
                    img: require("@/assets/images/flags/lu.png"),
                },
                {
                    name: "Luxemburg (Deutsch)",
                    value: "lu-de",
                    img: require("@/assets/images/flags/lu.png"),
                },
                {
                    name: "Norge",
                    value: "no",
                    img: require("@/assets/images/flags/no.png"),
                },
                {
                    name: "Nederland",
                    value: "nl",
                    img: require("@/assets/images/flags/nl.png"),
                },
                {
                    name: "Sverige",
                    value: "se",
                    img: require("@/assets/images/flags/se.png"),
                },
                {
                    name: "España",
                    value: "es",
                    img: require("@/assets/images/flags/es.png"),
                },
                {
                    name: "Italia",
                    value: "it",
                    img: require("@/assets/images/flags/it.png"),
                },
            ],
            selectedLang: {
                name: "",
                value: "",
            },
        }
    },
    methods: {
        //  Change route (current route with new lang parameter)
        changeLanguage(langCode) {
            this.$store.commit("account/setLanguage", langCode)
            window.location.href =
                window.location.origin + `/${langCode}/` + this.$route.href
        },
        updateLanguage(value) {
            this.selectedLang = value
            this.changeLanguage(this.selectedLang.value)
        },
        // Set selected language in dropdown
        setSelectedLanguage() {
            const language = this.$store.getters["account/getLanguage"] ?? "fr"
            this.selectedLang = this.langs.find(
                (item) => item.value === language,
            )
        },
    },
    created() {
        this.setSelectedLanguage()
    },
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/global.scss";

.language-selector {
    width: max-content;
    height: min-content;
}

.flag-wrapper {
    width: 20px;
    aspect-ratio: square;
}
</style>
